// EmailPreview — sandboxed iframe renderer for an email HTML body (replaces EmailPreviewComponent).
import { Box } from '@mui/material';
import { useSafeHtml } from '@/utils/safeHtml';

interface Props {
  html: string;
  height?: number | string;
}

export function EmailPreview({ html, height = 400 }: Props) {
  const safe = useSafeHtml(html);
  return (
    <Box
      component="iframe"
      title="email-preview"
      srcDoc={safe}
      sandbox=""
      sx={{
        width: '100%',
        height,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
      }}
    />
  );
}
